var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"station"},[_c('div',{staticClass:"station_top"},[_vm._t("default")],2),_vm._v(" "),_c('div',{staticClass:"station_text"},[_c('span',[_vm._v(_vm._s(_vm.item.name))]),_vm._v(" "),_c('div',{staticClass:"btn"},[_c('p',{on:{"click":_vm.update}},[_vm._v("修改")]),_vm._v(" "),_c('p',{on:{"click":_vm.del}},[_vm._v("删除")])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-cf5c0e6c","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/tangci/station.vue
// module id = null
// module chunks = 